<div class="chat-outer-wrapper">
    <div class="chat-inner-wrapper">
        <div class="chatBoxWrap">
            <div class="headPart">
                <div class="chatTitle">
                    <div class="playerWelcome">
                        <div class="greet">Welcome!</div>
                        <div class="playerinfo">{{user}}</div>
                    </div>
                    <!-- <div class="title">{{'common.' + gameCode | translate}}</div> -->
                </div>
                <div class="buttonwrap">
                    <div class="button contactBTN active" (click)="viewContact()">
                        <!-- <svg class="svgicon">
                            <use xlink:href="assets/images/chatroom/sprite-sheet-chaticons.svg#icon-contact"></use>
                        </svg> -->
                        <div class="onlinePlayers">
                            <div class="svgWrap">
                                <img src="assets/images/chatmember.svg">
                            </div>
                            <div class="playerCount">
                                <div class="count">{{userlist.length}}</div>
                                <div class="label">Online</div>
                            </div>
                        </div>
                    </div>
                    <div class="button closeBTN" (click)="leaveChat()">
                        <span>x</span>
                    </div>
                </div>
            </div>
            <div class="bodyPart">
                <div *ngIf="contact" class="contactlist">
                    <ul>
                        <li [ngClass]="{'self' : player == user}" *ngFor="let player of userlist;">
                            <span>{{player}}</span></li>
                    </ul>
                </div>
                <div class="containerBox" #scrollChat (scroll)="scrolled($event)">
                    <ng-container *ngFor="let item of messageArray; let i = index">
                        <div *ngIf="item.user != user && item.state == 'message'"
                            class="otherChatWrap bg-c{{checkUserColor(item.user)}}">
                            <div class="userIconWrap">
                                <div class="userIcon" style="background-color: #3112dd;">{{item.user.charAt(0)}}</div>
                                <!-- <img src="assets/images/chatroom/demoUser.jpg"    alt="Hannah Morgan"></div> -->
                                <!-- <span class="status offline"></span> -->
                            </div>
                            <div class="chatMsgBoxWrap">
                                <div class="chatMsgBox">
                                    <div class="username">{{item.user}}</div>
                                    <div class="msg">
                                        <p>{{item.message}}</p>
                                    </div>
                                    <div class="msgTime">
                                        <span>{{item.time}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.user == user && item.state == 'message'" class="masterChatWrap">
                            <div class="userIconWrap">
                                <div class="userIcon" style="background-color: #fcb913;">{{user.charAt(0)}}</div>
                                <!-- <span class="status online"></span> -->
                            </div>
                            <div class="chatMsgBoxWrap">
                                <div class="chatMsgBox">
                                    <div class="username">{{item.user}}</div>
                                    <div class="msg">
                                        <p>{{item.message}}</p>
                                    </div>
                                    <div class="msgTime">
                                        <span>{{item.time}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.state == 'warn'" class="systemChatWrap warning">
                            <div class="chatMsgBoxWrap">
                                <div class="chatMsgBox">
                                    <div class="msg">
                                        <p>Your message has been rejected. Please, do not use foul words.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.state == 'left' || item.state == 'join'" class="systemChatWrap info">
                            <div class="chatMsgBoxWrap">
                                <div class="chatMsgBox">
                                    <div class="msg">
                                        <p>{{item.user + ' ' + item.message}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="systemChatWrap success">
                        <div class="chatMsgBoxWrap">
                            <div class="chatMsgBox">
                                <div class="msg">
                                    <p><b>Congratulations!</b> Ram7856 for getting Bingo.</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                        <div *ngIf="item.state == 'danger'" class="systemChatWrap danger">
                            <div class="chatMsgBoxWrap">
                                <div class="chatMsgBox">
                                    <div class="msg">
                                        <p><strong>Banned:</strong> {{item.user}} has been banned from this chatroom</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="footPart">
                <div class="chatActionsWrap">
                    <div class="actionButtonWrap preAction">
                        <div class="buttonWrap">
                            <div class="button smileyBTN"
                                (click)="chatStatus === 'BANNED' ? $event.stopPropagation() : toggleEmojiPicker()">
                                <svg class="svgicon">
                                    <use xlink:href="assets/images/chatroom/sprite-sheet-chaticons.svg#icon-emoji">
                                    </use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="textareaWrap">
                        <textarea #chatArea [attr.disabled]="chatStatus === 'BANNED' ? 'disabled' : null"
                            name="chatTypeArea" (keyup)="handleKeyUp($event)" [(ngModel)]="messageText"
                            id="chatTypeArea" placeholder="Type a message..."></textarea>
                    </div>
                    <div class="actionButtonWrap postAction">
                        <div class="buttonWrap">
                            <emoji-mart class="emoji-mart" set="{{set}}" include="['people']" *ngIf="showEmojiPicker"
                                (emojiSelect)="addEmoji($event, chatArea)" title="Pick your emoji…"></emoji-mart>
                            <div class="button sendBTN"
                                (click)="chatStatus === 'BANNED' ? $event.stopPropagation() : sendMessage()">
                                <!-- <svg class="svgicon">
                                    <use xlink:href="assets/images/chatroom/sprite-sheet-chaticons.svg#icon-plane">
                                    </use>
                                </svg> -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20">
                                    <defs>
                                        <style>
                                            .cls-1 {
                                                fill-rule: evenodd
                                            }
                                        </style>
                                    </defs>
                                    <path id="icon-send"
                                        d="M3.812 2L27 11.677 3.812 22C2.811 22 2 20.387 2 20.387l3.623-7.669 12.681-.9-12.681-1.051L2 3.613S2.811 2 3.812 2z"
                                        class="cls-1" transform="translate(-2 -2)" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
